import { render, staticRenderFns } from "./NewsForm.vue?vue&type=template&id=1edf2a84&scoped=true"
import script from "./NewsForm.vue?vue&type=script&lang=js"
export * from "./NewsForm.vue?vue&type=script&lang=js"
import style0 from "./NewsForm.vue?vue&type=style&index=0&id=1edf2a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edf2a84",
  null
  
)

export default component.exports